export default function VerificationStatusNotice({ error, retry }: { error: boolean; retry: () => void }) {
  return <div className="mx-auto max-w-md px-5 py-12 text-center">
    <p role={error ? "alert" : "status"} className="text-sm leading-6 text-stone-600">
      {error ? "인증 상태를 확인하지 못했어요." : "인증 상태를 확인하고 있어요."}
    </p>
    {error && <button type="button" onClick={retry} className="mt-5 min-h-11 rounded-xl bg-orange-600 px-6 py-3 text-sm font-semibold text-white hover:bg-orange-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-600">다시 확인</button>}
  </div>;
}
